import {
    getCalendarEntry,
    getCalendarEntryByFolderId,
    getDefaultCalendar,
} from 'owa-calendar-cache';

import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { LocalCalendarEntry } from 'owa-graph-schema';
import { OnlineMeetingProviderType } from './OnlineMeetingProviderType';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';

/**
 * Returns the calendar online meeting provider info for the event in the compose form
 */
export function getOnlineMeetingProviderInfo(
    event: CalendarEvent
): OnlineMeetingProviderType[] | null {
    let onlineMeetingProviders;

    if (event?.ParentFolderId) {
        let calendarEntry: LocalCalendarEntry = getCalendarEntryByFolderId(
            event.ParentFolderId.Id
        ) as LocalCalendarEntry;

        if (!calendarEntry) {
            if (
                isFeatureEnabled('cal-mf-calendarPickerTeams') ||
                isHostAppFeatureEnabled('teamsCalendarPicker')
            ) {
                // Work Item 58585: Clean code once the teams/channels are added to the cache
                return ['TeamsForBusiness'];
            } else {
                // Remove early return after fixing https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/62274
                // VSO 62274 - Longterm fix for customer escalation - investigate null calendar entry for deeplink
                return null;
            }
        }

        // If the current calendar is a GroupMailbox Calendar, then use the defaultOnlineProvider
        // property of user's default calendar
        if (calendarEntry.IsGroupMailboxCalendar) {
            let defaultCalendar = getDefaultCalendar();
            calendarEntry = getCalendarEntry(defaultCalendar) as LocalCalendarEntry;
        }

        onlineMeetingProviders = getOnlineMeetingProviderForCalendar(calendarEntry);
    }

    return onlineMeetingProviders;
}

export function getDefaultOnlineMeetingProvider(event: CalendarEvent): OnlineMeetingProviderType {
    let defaultOnlineMeetingProvider;

    if (event?.ParentFolderId) {
        let calendarEntry: LocalCalendarEntry = getCalendarEntryByFolderId(
            event.ParentFolderId.Id
        ) as LocalCalendarEntry;

        if (!calendarEntry) {
            // TODO: VSO #76824 Remove `isHostAppFeatureEnabled` check once Teams OPX partner is added to flight overrides
            if (
                isFeatureEnabled('cal-mf-calendarPickerTeams') ||
                isHostAppFeatureEnabled('teamsCalendarPicker')
            ) {
                // Work Item 58585: Clean code once the teams/channels are added to the cache
                return 'TeamsForBusiness';
            } else {
                // Remove early return after fixing https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/62274
                // VSO 62274 - Longterm fix for customer escalation - investigate null calendar entry for deeplink
                return null;
            }
        }

        // If the current calendar is a GroupMailbox Calendar, then use the defaultOnlineProvider
        // property of user's default calendar
        if (calendarEntry.IsGroupMailboxCalendar) {
            let defaultCalendar = getDefaultCalendar();
            calendarEntry = getCalendarEntry(defaultCalendar) as LocalCalendarEntry;
        }

        defaultOnlineMeetingProvider = calendarEntry.DefaultOnlineMeetingProvider;
    }

    return defaultOnlineMeetingProvider;
}

function getOnlineMeetingProviderForCalendar(
    calendar: LocalCalendarEntry
): OnlineMeetingProviderType[] {
    if (!calendar) {
        return null;
    }

    return calendar.AllowedOnlineMeetingProviders as OnlineMeetingProviderType[];
}
